import { Injectable } from '@angular/core';
import { Platform, AlertController } from '@ionic/angular';
import { Client } from './client.class';
import { RequestService } from './requestService.service';
import { AssignCase } from './assignCases.class';
import { OfflineManager } from './offlineManager.service';
import { CacheConfiguration } from './entities/cacheConfig.class';
import { CacheCoordinates } from './entities/cacheCoordinates.class';
import { Device } from '@capacitor/device';
import { Translate } from './translate';
import * as moment from 'moment';
import { Uptime } from '@ionic-native/uptime/ngx';
import { StorageService } from './storageservice';
import { CacheTime } from './entities/cacheTime.class';
import { MomentDefaultFormat, DateTimeWebFormat, DateTimeFormat } from './entities/constantsExport.class';
import { Capacitor } from '@capacitor/core';
import { BusinessConfigurationMessages } from '../shared/enumerations.class';
import { UptimeService } from './uptimeService.service';
import { ConnectionStatus } from 'src/shared/enumerations.class';
import { WorkerCoordinates } from './entities/workerCoordinates.class';
import { RollbarErrorHandler } from './rollbar.service';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { Position, Geolocation } from '@capacitor/geolocation';
import { Camera } from '@capacitor/camera';
import { LocalNotifications, LocalNotificationSchema } from '@capacitor/local-notifications';
import { App } from '@capacitor/app';
import { SpeechRecognition } from '@awesome-cordova-plugins/speech-recognition/ngx';
//import { NewRelicService } from './newrelic.service';


@Injectable()
export class MobileService {

    currentClient: Client;
    currentCase: AssignCase;
    onDevice: boolean = false;
    networkConnected: boolean = false;
    mainConstraint: Array<any> = []
    careTrackConstraint: any = {};
    isAndroid: boolean = false;
    visitConstraintEndTime: any = {};
    scheduledNotifications: Array<any> = [];
    maxCalendarDate: Date = new Date(2028, 11, 31);
    minCalendarDate: Date = new Date(2015, 0, 1);
    backgroundClass: string = "loginbackground";
    limit: number = 50;
    deviceUniqueIdentifier: string = "";
    lastLocation: CacheCoordinates = new CacheCoordinates(0, 0, 0);

    uptimeTolerance: number = 0;
    refreshMinutes: number = 1;
    uptimeVal: string;
    additionalDebug: string;
    lastKnownUptime: string = "";

    offlineUptimeWarning: boolean = false;
    lastKnownInterval: any;
    offlineTimeChecked: boolean = false;

    permissionList: any = [
        // this.permissions.PERMISSION.ACCESS_COARSE_LOCATION,
        // this.permissions.PERMISSION.ACCESS_FINE_LOCATION,
        // this.permissions.PERMISSION.ACCESS_BACKGROUND_LOCATION,
        // this.permissions.PERMISSION.ACCESS_NETWORK_STATE,
        // this.permissions.PERMISSION.ACCESS_WIFI_STATE,
        // this.permissions.PERMISSION.CAMERA,
        // this.permissions.PERMISSION.INTERNET
    ]
    geolocationOptions: PositionOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    }
    geolocationMapOptions: PositionOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    }
    faioStatus: any;


    constructor(
        private plt: Platform,
        private alert: AlertController,
        // private localNotifications: LocalNotifications,
        private requestService: RequestService,
        //private permissions: AndroidPermissions,
        private offlineManager: OfflineManager,
        private uptime: Uptime,
        private uptimeService: UptimeService,
        private storage: StorageService,
        private rollbarErrorHandler: RollbarErrorHandler,
        private diagnostic: Diagnostic,
         private speechRecognition: SpeechRecognition,
        //private newRelicService: NewRelicService,
    ) {

    }

    getDeviceIdentifier() {
        if (this.deviceUniqueIdentifier == "") {
            Device.getId().then((deviceId: any) => {
                this.deviceUniqueIdentifier = deviceId.identifier;
                return this.deviceUniqueIdentifier;
            }).catch((error: any) => {
                return "";
            });
        }

        return this.deviceUniqueIdentifier;
    }

    async checkPermissions() {
        if (this.checkIfMobile()) {
            // Check notifications permission
            const permissionStatus = await LocalNotifications.checkPermissions();
            if (permissionStatus.display === 'prompt' || permissionStatus.display === 'denied') {
                await this.requestPermissions();
            }

            // Check camera permission
            const cameraPermissionStatus = await Camera.checkPermissions();
            if (cameraPermissionStatus.camera !== 'granted') {
                await this.requestPermissions();
            }

            // Check geolocation permission
            const geoPermissionStatus = await Geolocation.checkPermissions();
            if (geoPermissionStatus.location !== 'granted') {
                await this.requestPermissions();
            }

            const audioPermisionStatus = await  await this.speechRecognition.hasPermission();
            if (audioPermisionStatus === false) {
                await this.speechRecognition.requestPermission();
            }
          
            // this.permissions.checkPermission(this.permissionList).then(data => {
            //     if (!data.hasPermission) {
            //         this.requestPermissions();
            //     }
            // }, reject => {
            //     console.log(reject);
            // });
        }
    }

    async requestPermissions() {
        if (this.checkIfMobile()) {
            await this.requestCameraPermission();
            await this.requestGeolocationPermission();
            await this.requestLocalNotificationsPermission();
            // this.permissions.requestPermissions(this.permissionList).then(data => {
            //     return;
            // }, reject => {
            //     console.log(reject);
            // });
        }
    }

    checkIfMobile(): boolean {
        return Capacitor.isNativePlatform();
    }

    async requestLocalNotificationsPermission() {
        try {
            const requestStatus = await LocalNotifications.requestPermissions();

            if (requestStatus.display === 'granted') {
                console.log('Notification permission granted after request');
            } else {
                console.log('Notification permission denied');
            }
        } catch (error) {
            console.error('Failed to request notification permission:', error);
        }
    }

    async requestCameraPermission() {
        try {
            const permission = await Camera.requestPermissions();
            if (permission.camera === 'denied') {
                console.log('Camera permission denied.');
            } else {
                console.log('Camera permission granted.');
            }
        } catch (error) {
            console.error('Failed to request camera permission:', error);
        }
    }

    async requestGeolocationPermission() {
        try {
            const permission = await Geolocation.requestPermissions();
            if (permission.location === 'denied') {
                console.log('Geolocation permission denied.');
            } else {
                console.log('Geolocation permission granted.');
            }
        } catch (error) {
            console.error('Failed to request geolocation permission:', error);
        }
    }

    gotLocationError: boolean = false;
    testingGpsFailure: boolean = false;//!!! true for TESTING only, false in prod !!!
    getLocation(isOnline: boolean, refresh: boolean = false, isPressed: boolean = false): Promise<Position> {
        return new Promise((resolve, reject) => {
            this.getCoordinates(refresh, isPressed).then((response) => {
                this.gpsIsTurnedOn = (response === 0);
                if (response === 0) {
                    resolve(this.coordinates);
                } else {
                    this.gpsErrorHandling(response, refresh, isPressed);
                    reject(response);
                }
            });
        });
    }


    coordinates: Position;
    getCoordinates(refresh: boolean = false, isPressed: boolean = false): Promise<number> {
        return new Promise(async (resolve) => {
            const platform = Capacitor.getPlatform();

            if (platform === 'ios' || platform === 'android') {
                try {
                    const position: Position = await Geolocation.getCurrentPosition(this.geolocationOptions);
                    this.gotLocationError = false;
                    this.coordinates = position;
                    this.gpsRetries = 0;
                    // this.newRelicService.recordBreadcrumb('Get_Gps_Configs', {
                    //     service: 'mobileLogin-api.service',
                    //     methodName: 'getCoordinates(refresh,isPressed)',
                    //     refresh: refresh,
                    //     isPressed: isPressed,
                    //     gotLocationError: this.gotLocationError,
                    //     gpsRetries: this.gpsRetries,
                    //     CoordinatesCoordsLatitude: this.coordinates.coords.latitude,
                    //     CoordinatesCoordsLongitude: this.coordinates.coords.longitude,
                    //     CoordinatesCoordsAccuracy: this.coordinates.coords.accuracy,
                    //     CoordinatesCoordsTimestamp: this.coordinates.timestamp,
                    //     gpsRetryLimit: this.gpsRetryLimit,
                    //     //isOnline: this.networkService.userIsOnline2(),
                    //     timestamp: Date.now()
                    // });
                    resolve(0);
                } catch (error: any) {
                    //this.newRelicService.recordError("Error in mobileLogin-api.service.getCoordinates() error.code is: " + error.code + " Message is: " + error.message, error.stack);
                    if (!this.gotLocationError) this.gotLocationError = true;
                    if (!this.testingGpsFailure) {
                        this.gpsErrorHandling(error.code ?? 1, refresh, isPressed);
                        resolve(error.code ?? 1);
                    } else {
                        setTimeout(() => {
                            this.gpsErrorHandling(2, refresh, isPressed);
                            resolve((error.code ?? 1) + 1);
                        }, this.geolocationOptions.timeout);
                    }
                }
            } else {
                // Web fallback
                navigator.geolocation.getCurrentPosition(
                    (success) => {
                        this.gotLocationError = false;
                        this.coordinates = success;
                        this.gpsRetries = 0;
                        resolve(0);
                    },
                    (error) => {
                        if (!this.gotLocationError) this.gotLocationError = true;
                        if (!this.testingGpsFailure) {
                            this.gpsErrorHandling(error.code, refresh, isPressed);
                            resolve(error.code);
                        } else {
                            setTimeout(() => {
                                this.gpsErrorHandling(2, refresh, isPressed);
                                resolve(error.code + 1);
                            }, this.geolocationOptions.timeout);
                        }
                    },
                    this.geolocationOptions
                );
            }
        });
    }


    gpsIsTurnedOffWarning: boolean = false;
    gpsIsTurnedOffWarnOnce: boolean = true;
    gpsIsTurnedOn: boolean = false;
    gpsRetries: number = 0;
    gpsRetryLimit: number = 0;
    gpsRetryConfigLimit: number = 3;
    acceptOnlyInconfiguredRange: boolean = false;
    acceptOnlyIfGPSTurnedOn: boolean = false;
    getGpsConfigs() {
        this.acceptOnlyInconfiguredRange = this.hasPermission(BusinessConfigurationMessages.ReportArrivalDepartureOnlyIfGPSWithinRange);
        this.acceptOnlyIfGPSTurnedOn = this.hasPermission(BusinessConfigurationMessages.MobileDontAllowLoginWithoutGPSTurnedOn);
        var configValue = this.getConfigurationValue(BusinessConfigurationMessages.ProceedIfGPSFails) && this.acceptOnlyInconfiguredRange;
        this.gpsRetryLimit = (configValue != undefined) ? this.gpsRetryConfigLimit : 0;
        // this.newRelicService.recordBreadcrumb('Get_Gps_Configs', {
        //     service: 'mobileLogin-api.service',
        //     methodName: 'getGpsConfigs()',
        //     acceptOnlyInconfiguredRange: this.acceptOnlyInconfiguredRange,
        //     acceptOnlyIfGPSTurnedOn: this.acceptOnlyIfGPSTurnedOn,
        //     configValue: configValue,
        //     gpsRetryLimit: this.gpsRetryLimit,
        //     //isOnline: this.networkService.userIsOnline2(),
        //     timestamp: Date.now()
        // });
    }
    gpsErrorHandling(errorCode: number, refresh: boolean = false, isPressed: boolean = false) {
        // this.newRelicService.recordBreadcrumb('Gps_error_Hendling', {
        //     service: 'mobileLogin-api.service',
        //     methodName: 'gpsErrorHandling(errorCode,refresh,isPressed)',
        //     acceptOnlyInconfiguredRange: this.acceptOnlyInconfiguredRange,
        //     acceptOnlyIfGPSTurnedOn: this.acceptOnlyIfGPSTurnedOn,
        //     errorCode: errorCode,
        //     refresh: refresh,
        //     isPressed: isPressed,
        //     gpsRetryLimit: this.gpsRetryLimit,
        //     gpsIsTurnedOn: this.gpsIsTurnedOn,
        //     gpsIsTurnedOffWarnOnce: this.gpsIsTurnedOffWarnOnce,
        //     gpsIsTurnedOffWarning: this.gpsIsTurnedOffWarning,
        //     //isOnline: this.networkService.userIsOnline2(),
        //     timestamp: Date.now()
        // });
        if (refresh) {
            if (errorCode == 1) {
                this.gpsCalls = 0;
                if (this.gpsIsTurnedOn) this.gpsIsTurnedOffWarnOnce = true;
                if ((this.gpsIsTurnedOffWarnOnce || isPressed) && this.acceptOnlyIfGPSTurnedOn == false) this.gpsIsTurnedOffWarning = true;
                this.gpsIsTurnedOffWarnOnce = false;
                this.gpsIsTurnedOn = false;
            } else if (this.gpsRetryLimit > 0) {
                this.gpsRetries++;
                this.gpsIsTurnedOffWarnOnce = true;
            }
        }
    }

    async gpsAcceptOnlyIfGPSTurnedOn(userName: string, password: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.requestService.getBusinessConfigurationByUsernameAndPassword(userName, password, BusinessConfigurationMessages.MobileDontAllowLoginWithoutGPSTurnedOn).then(async data => {
                if (data != null && data.Message == BusinessConfigurationMessages.MobileDontAllowLoginWithoutGPSTurnedOn && data.Active == true) {
                    this.acceptOnlyIfGPSTurnedOn = true;
                } else {
                    this.acceptOnlyIfGPSTurnedOn = false;
                }

                if (!this.acceptOnlyIfGPSTurnedOn) {
                    resolve(true);
                    return;
                }

                if (this.isNativePlatform()) {
                    await Geolocation.checkPermissions()
                        .then(permissionStatus => {
                            if (permissionStatus.location === 'granted') {
                                resolve(true);
                            } else {
                                resolve(false);
                            }
                        }).catch(error => {
                            console.log(error);
                            resolve(false);
                        });

                } else {
                    resolve(true);
                }
            });
        });
    }

    gpsAcceptTime() {
        return this.gpsRetries >= this.gpsRetryLimit && this.gpsRetryLimit != 0 && this.acceptOnlyInconfiguredRange;
    }

    gpsTimeLeft = 0;
    gpsTimer: any;
    gpsRetryInterval = 15;
    gpsCalls = 0;
    gpsCountDown() {
        this.gpsCalls++;
        if (this.gpsRetryLimit > 0 && this.gpsRetries < this.gpsRetryLimit && (this.gpsIsTurnedOn || this.testingGpsFailure)) {
            let retries = Math.max(this.gpsRetryLimit - this.gpsCalls, 0);
            if (this.gpsRetryLimit - this.gpsCalls >= 0) this.gpsTimeLeft = this.geolocationOptions.timeout / 1000 + retries * this.gpsRetryInterval;
            if (this.gpsRetries >= this.gpsRetryLimit) this.gpsTimeLeft = 0;
            if (this.gpsCalls == 1) {
                this.gpsTimer = setInterval(() => {
                    if (this.gpsTimeLeft <= 0 || this.gpsRetries >= this.gpsRetryLimit) {
                        this.gpsTimeLeft = 0;
                        clearInterval(this.gpsTimer);
                    }
                    if (this.gpsTimeLeft > 0) this.gpsTimeLeft -= 1;
                    if (!this.gpsIsTurnedOn && !this.testingGpsFailure) {
                        this.gpsCalls = 0;
                        clearInterval(this.gpsTimer);
                    }
                }, 1000);
            }
        }
    }

    checkPlatform(): boolean {
        if (this.plt.is("android")) {
            this.isAndroid = true;
        }
        if (this.plt.is('mobile')) {
            this.onDevice = true;
            return this.onDevice;
        }
    }

    setBackgroundClass() {
        switch (this.requestService.workerData.BusinessId) {
            case 90:
                {
                    this.backgroundClass = "loginbackground-intel";
                    break;
                }
            case 5591:
                {
                    this.backgroundClass = "loginbackground-intel";
                    break;
                }
            case 5286:
                {
                    this.backgroundClass = "loginbackground"
                    break;
                }
            default:
                {
                    this.backgroundClass = "loginbackground"
                    break;
                }
        }
    }

    checkIfOnMobile(): boolean {
        if (this.plt.is('mobileweb')) {
            return false;
        }
        return true;
    }

    checkIfDesktop(): boolean {
        if (this.plt.is('desktop')) {
            return true;
        }
        return true;
    }

    setNotification(notif: LocalNotificationSchema) {
        try {
            if (this.checkIfOnMobile()) {
                this.scheduledNotifications.push(notif);
                this.scheduleNotif({
                    notifications: [notif]
                });
            }
        } catch (error) {
            console.log(error)
        }

    }

    clearAllNotifForPatient() {
        try {
            if (this.checkIfOnMobile()) {
                const notificationsToClear = this.scheduledNotifications
                    .filter(x => x.id === this.currentClient.patientId);

                notificationsToClear.forEach(notif => {
                    LocalNotifications.cancel({ notifications: [notif] });
                });
                this.scheduledNotifications = this.scheduledNotifications.filter(x => x.id !== this.currentClient.patientId);
            }
        } catch (error) {
            console.log(error)
        }

    }

    async scheduleNotif(notif) {
        try {
            await LocalNotifications.schedule({
                notifications: [
                    {
                        title: notif.title,
                        body: notif.text,
                        id: this.currentClient.patientId,
                        schedule: {
                            at: new Date(notif.date.format("MM/DD/YYYY hh:mm A")),
                        },
                        sound: this.isAndroid ? 'file://sound.mp3' : 'file://beep.caf',
                        extra: {

                        },
                        attachments: [],
                        actionTypeId: '',
                        channelId: 'default',
                        smallIcon: 'ic_stat_icon',
                        largeIcon: 'ic_large_icon',
                        ongoing: false,
                        autoCancel: true,
                    },
                ],
            });
        } catch (error) {
            console.log(error)
        }

    }

    async presentAlert(message, title = "") {
        title = '' + title;
        let alert = await this.alert.create({
            message: message,
            buttons: [Translate.getTranslation('Ok')]
        });
        alert.present();
    }

    async hasLocalNotifPermissions() {
        if (this.checkIfMobile()) {
            const permissionStatus = await LocalNotifications.checkPermissions();

            if (permissionStatus.display === 'granted') {
                console.log('Notification permission granted');
            } else if (permissionStatus.display === 'prompt' || permissionStatus.display === 'denied') {
                const requestStatus = await LocalNotifications.requestPermissions();

                if (requestStatus.display === 'granted') {
                    console.log('Notification permission granted after request');
                } else {
                    console.log('Notification permission denied');
                }
            }
        }
    }

    convertToHoursMins(time: number) {

        var hours = Math.floor(time / 60);
        var minutes = time % 60;

        return { hours, minutes };
    }

    isConfigured(message: string, value: any) {
        var config = false;
        this.offlineManager.cacheData.Configs.forEach(element => {
            if (element.Message == message && element.Value == value) {
                config = true;
                return;
            }
        });

        return config;
    }

    hasPermission(message: string) {
        var config = false;
        this.offlineManager.cacheData.Configs.forEach(element => {
            if (element.Message == message && element.Value == "1") {
                config = true;
                return true;
            }
        });

        return config;
    }

    isConfigured2(message: string) {
        var config = false;
        this.offlineManager.cacheData.Configs.forEach(element => {
            if (element.Message == message && element.Active == true) {
                config = true;
                return;
            }
        });

        return config;
    }

    hasSignature(signatureType: number) {
        var config = false;

        this.offlineManager.sessionCurrentVisit.ExistingSignatureTypes.forEach(element => {
            if (element == signatureType) {
                config = true;
            }
        });

        return config;
    }

    getConfigurationValue(message: string) {
        var config: CacheConfiguration = this.offlineManager.cacheData.Configs.find(c => c.Message == message);

        if (!config || !config.Active) {
            return undefined;
        }

        return config.Value;
    }


    isPlatformiOS(): boolean {
        return Capacitor.getPlatform() === 'ios';
    }

    isPlatformAndroid(): boolean {
        return Capacitor.getPlatform() === 'android';
    }

    isPlatformMobileWeb(): boolean {
        return Capacitor.getPlatform() === 'web' && /Mobi|Android/i.test(navigator.userAgent);
    }

    isWeb(): boolean {
        return Capacitor.getPlatform() === 'web';
    }

    isNativePlatform(): boolean {
        const platform = Capacitor.getPlatform();
        return platform === 'ios' || platform === 'android';
    }

    isCordova(): boolean {
        const platform = Capacitor.getPlatform();
        return platform === 'ios' || platform === 'android';
    }

    getUptimeConfigurations() {
        this.uptimeTolerance = this.getConfigurationValue(BusinessConfigurationMessages.MobileUptimeTolerance) != undefined ? parseInt(this.getConfigurationValue(BusinessConfigurationMessages.MobileUptimeTolerance)) : 0;
        if (this.uptimeTolerance < 0) this.uptimeTolerance = 0;
        this.offlineManager.uptimeTolerance = this.uptimeTolerance;
        this.uptimeService.uptimeTolerance = this.uptimeTolerance;
        this.refreshMinutes = this.getConfigurationValue(BusinessConfigurationMessages.MobileRefreshInterval) != undefined ? parseInt(this.getConfigurationValue(BusinessConfigurationMessages.MobileRefreshInterval)) : 1;
        if (this.refreshMinutes < 1) this.refreshMinutes = 1;
        this.requestService.pastDays = this.getConfigurationValue(BusinessConfigurationMessages.DisplayVisitsFromXPastDays) != undefined ? parseInt(this.getConfigurationValue(BusinessConfigurationMessages.DisplayVisitsFromXPastDays)) : 0;
        // this.newRelicService.recordBreadcrumb('Get_uptime_Configurations', {
        //     service: 'mobileLogin-api.service',
        //     methodName: 'getUptimeConfigurations()',
        //     uptimeTolerance: this.uptimeTolerance,
        //     refreshMinutes: this.refreshMinutes,
        //     pastDays: this.requestService.pastDays,
        //     //isOnline: this.networkService.userIsOnline2(),
        //     timestamp: Date.now()
        // });
    }

    getActualTime(storedTime, storedZone, isArrival, patientServiceOrderId, flow = 0) {
        return new Promise<CacheTime>((resolve, reject) => {
            this.uptime.getUptime(true).then(uptime => {
                let commonDiff = localStorage.getItem("commonDiff");
                let origUptime = uptime;
                let currentUptime = (parseInt(uptime) + parseInt(localStorage.getItem("restartUptime"))).toString();
                let uptimeDiff = ((parseInt(currentUptime) - parseInt(localStorage.getItem("storedUptime"))) / 1000);
                let stored = moment(storedTime, DateTimeFormat);
                let storedDiff = moment().diff(stored, 'seconds');
                let differenceInMin = (storedDiff - uptimeDiff) / 60;

                var time1 = moment().subtract(differenceInMin, 'minutes');
                var time2 = moment(stored).add(uptimeDiff / 60, 'minutes');
                var timeDiff = moment(time1).diff(time2);
                let actualTime = moment(time1);
                if (Math.abs(timeDiff) > this.uptimeTolerance * 60000) {
                    actualTime = time2;
                }
                actualTime = actualTime.add(commonDiff);
                let restartAdd = localStorage.getItem("restartAdd") != '' ? parseInt(localStorage.getItem("restartAdd")) : 0;

                this.uptimeVal = " storedTime=" + storedTime + " storedZone=" + storedZone
                    + "\n restartUptime=" + localStorage.getItem("restartUptime") + " restartUptime(m)=" + parseInt(localStorage.getItem("restartUptime")) / 60000
                    + "\n origUptime=" + origUptime + " uptime=" + currentUptime + " storedUptime=" + localStorage.getItem("storedUptime")
                    + "\n uptimeDiff(s)=" + uptimeDiff + " uptimeDiff(m)=" + uptimeDiff / 60 + " uptimeDiff(h)=" + uptimeDiff / 3600
                    + "\n storedDiff(s)=" + storedDiff + " storedDiff(m)=" + storedDiff / 60 + " storedDiff(h)=" + storedDiff / 3600
                    + "\n differenceInMin=" + differenceInMin + " diff=" + timeDiff + " " + moment(time1).diff(time2) + " " + Math.abs(moment(time1).diff(time2))
                    + "\n restartAdd=" + restartAdd
                    + "\n | time1=" + time1.format("HH:mm:ss") + " time2=" + time2.format("HH:mm:ss") + " | " + actualTime.format("HH:mm:ss")
                    + "\n common=" + localStorage.getItem("commonTime") + " commonDiff=" + localStorage.getItem("commonDiff")
                    + "\n ||| " + this.additionalDebug
                    + "\n lkt=" + localStorage.getItem("lastKnownTime") + " lku=" + localStorage.getItem("lastKnownUptime");
                if (flow == 5 && isArrival) flow = 2;
                if (flow > 2) this.rollbarErrorHandler.offlineLog("Offline calculations: " + this.offlineManager.sessionCurrentVisit.ServiceOrderId + " " + this.uptimeVal);

                var timePoint = new CacheTime(this.offlineManager.sessionCurrentVisit.ServiceOrderId, isArrival, moment(actualTime, DateTimeFormat).format(DateTimeFormat), storedZone, parseInt(uptime), false, restartAdd, false, "", patientServiceOrderId);
                //cacheTimePoint stored in UTC
                var cacheTimePoint = new CacheTime(timePoint.serviceOrderId, timePoint.isArrival, timePoint.time, timePoint.timezone, timePoint.uptime, timePoint.synced, timePoint.restart, timePoint.negative, "", timePoint.patientServiceOrderId);
                cacheTimePoint.time = moment(cacheTimePoint.time).subtract(storedZone).format(DateTimeFormat);
                cacheTimePoint.negative = cacheTimePoint.restart != 0 && (moment(cacheTimePoint.time).isBefore(moment(localStorage.getItem("commonTime"), DateTimeFormat))
                    && Math.abs(moment(cacheTimePoint.time).diff(moment(localStorage.getItem("commonTime"), DateTimeFormat))) > this.uptimeTolerance * 60000);
                this.uptimeService.addToCacheTimeArray(cacheTimePoint);

                // this.newRelicService.recordBreadcrumb('Get_Actual_Time', {
                //     service: 'mobileLogin-api.service',
                //     methodName: 'getActualTime(storedTime, storedZone, isArrival, patientServiceOrderId, flow)',
                //     commonDiff: commonDiff,
                //     origUptime: origUptime,
                //     currentUptime: currentUptime,
                //     uptimeDiff: uptimeDiff,
                //     stored: stored,
                //     storedDiff: storedDiff,
                //     differenceInMin: differenceInMin,
                //     time1: time1,
                //     time2: time2,
                //     timeDiff: timeDiff,
                //     actualTime: actualTime,
                //     uptimeTolerance: this.uptimeTolerance,
                //     restartAdd: restartAdd,
                //     flow: flow,
                //     storedTime: storedTime,
                //     storedZone: storedZone,
                //     isArrival: isArrival,
                //     patientServiceOrderId: patientServiceOrderId,
                //     CacheTimePointTime: cacheTimePoint.time,
                //     CacheTimePointServiceOrderId: cacheTimePoint.serviceOrderId,
                //     CacheTimePointUptime: cacheTimePoint.uptime,
                //     CacheTimePointSynced: cacheTimePoint.synced,
                //     CacheTimePointRestart: cacheTimePoint.restart,
                //     CacheTimePointNegative: cacheTimePoint.negative,
                //     //isOnline: this.networkService.userIsOnline2(),
                //     timestamp: Date.now()
                // });

                resolve(timePoint);
            })
                .catch((error: any) => {
                    reject(error.message);
                });
        });
    }

    // updateStoredUptime() {
    //     if (!this.plt.is('desktop') && this.plt.is('cordova')) {
    //         this.lastKnownInterval = BackgroundTask.beforeExit(async () => {
    //             setInterval(() => {
    //                 this.uptime.getUptime(true).then(uptime => {
    //                     this.uptimeService.setLastKnownUptime(uptime);
    //                 });
    //             }, this.refreshMinutes * 60000);
    //         });
    //     }
    // }
    private updateInterval: any;
    updateStoredUptime() {
        if (!this.plt.is('desktop')) {
            // Detect when the app goes background/foreground
            App.addListener('appStateChange', (state) => {
                if (state.isActive) {
                    console.log('App is active, resuming uptime updates');
                    this.startUptimeUpdates();
                } else {
                    console.log('App is in background, stopping updates');
                    this.stopUptimeUpdates();
                }
            });

            // Start updates immediately
            this.startUptimeUpdates();
        }
    }
    startUptimeUpdates() {
        if (this.updateInterval) return;

        this.updateInterval = setInterval(() => {
            this.uptime.getUptime(true).then((uptime) => {
                this.uptimeService.setLastKnownUptime(uptime);
                console.log('Uptime updated:', uptime);
            });
        }, this.refreshMinutes * 60000);
    }

    stopUptimeUpdates() {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }


    trustPhoneTimeAfterRestart: boolean = true;
    checkOfflineUptime() {
        return this.uptime.getUptime(true).then(uptime => {
            this.offlineUptimeWarning = false;
            let storedUptime = parseInt(localStorage.getItem("storedUptime"));
            let lastKnownUptime = parseInt(localStorage.getItem("lastKnownUptime"));
            let lastKnownTime = moment(localStorage.getItem("lastKnownTime"), DateTimeFormat);
            let restartUptime = localStorage.getItem("restartUptime");
            let restartZoneDiff = moment().utcOffset();
            let restartDiff = moment().diff(lastKnownTime) - restartZoneDiff * 60000 - parseInt(localStorage.getItem("commonDiff"));
            let diff2 = Math.abs(restartDiff - parseInt(uptime) + lastKnownUptime);

            // this.newRelicService.recordBreadcrumb('OfflineUptimeCheck_Start', {
            //     service: 'mobileLogin-api.service',
            //     methodName: 'checkOfflineUptime()',
            //     uptime,
            //     storedUptime,
            //     lastKnownUptime,
            //     restartUptime,
            //     lastKnownTime: lastKnownTime.format(DateTimeFormat),
            //     restartZoneDiff,
            //     restartDiff,
            //     diff2,
            //     commonDiff: localStorage.getItem("commonDiff"),
            //     //isOnline: this.networkService.userIsOnline2(),
            //     timestamp: Date.now()
            // });

            if (!isNaN(lastKnownUptime) && diff2 > this.refreshMinutes * 60000 && parseInt(uptime) < storedUptime && parseInt(uptime) < lastKnownUptime) {
                let restartUptimeNew = parseInt(localStorage.getItem("restartUptime")) + parseInt(localStorage.getItem("lastKnownUptime"))
                    + restartDiff - parseInt(uptime);
                let restartTimePhone = moment().add(- restartZoneDiff * 60000 - parseInt(uptime));
                let restartUptimePhone = parseInt(localStorage.getItem("restartUptime")) + parseInt(localStorage.getItem("lastKnownUptime"))
                    + moment(restartTimePhone, DateTimeFormat).diff(lastKnownTime);

                let restartTime = lastKnownTime.add(restartDiff);
                if (this.trustPhoneTimeAfterRestart) {
                    restartUptimeNew = restartUptimePhone;
                    restartTime = restartTimePhone;
                }
                localStorage.setItem("restartUptime", restartUptimeNew.toString());
                localStorage.setItem("restartTime", restartTime.format(DateTimeFormat));

                let restartAdd = (localStorage.getItem("restartAdd") != "" ? parseInt(localStorage.getItem("restartAdd")) : 0) + restartDiff;
                localStorage.setItem("restartAdd", restartAdd.toString());
                this.offlineUptimeWarning = true;

                // this.newRelicService.recordBreadcrumb('OfflineUptime_RestartDetected', {
                //     service: 'mobileLogin-api.service',
                //     methodName: 'checkOfflineUptime()',
                //     restartUptimeNew,
                //     restartTime: restartTime.format(DateTimeFormat),
                //     restartAdd,
                //     restartDiff,
                //     trustPhoneTimeAfterRestart: this.trustPhoneTimeAfterRestart,
                //     //isOnline: this.networkService.userIsOnline2(),
                //     timestamp: Date.now()
                // });

                var timePoint = new CacheTime(-1, false, moment(restartTime, DateTimeFormat).format(DateTimeFormat), 0, parseInt(restartUptime), false, restartAdd, restartDiff < 0, "", 0);
                this.uptimeService.addToCacheTimeArray(timePoint);

                this.lastKnownUptime = "case1: lkt=" + localStorage.getItem("lastKnownTime") + " lku=" + localStorage.getItem("lastKnownUptime")
                    + "\n moment=" + moment().format(DateTimeFormat) + " uptime=" + uptime
                    + "\n restartZoneDiff=" + restartZoneDiff + " restartDiff=" + restartDiff
                    + "\n restartUptime(before)=" + restartUptime + " restart=" + localStorage.getItem("restartUptime")
                    + "\n restartAdd=" + restartAdd
                    + "\n restartTime=" + restartTime.format(DateTimeFormat) + " restartTime(local)=" + localStorage.getItem("restartTime")
                    + "\n diff2=" + diff2
                    + "\n common=" + localStorage.getItem("commonTime") + " commonDiff=" + localStorage.getItem("commonDiff");
                this.additionalDebug = this.lastKnownUptime;
                this.rollbarErrorHandler.offlineLog("Offline Restart: " + this.additionalDebug);
            } else {
                this.lastKnownUptime = "case2: lkt=" + localStorage.getItem("lastKnownTime") + " lku=" + localStorage.getItem("lastKnownUptime")
                    + "\n moment=" + moment().format(DateTimeFormat) + " uptime=" + uptime
                    + "\n restartZoneDiff=" + restartZoneDiff + " restartDiff=" + restartDiff
                    + "\n restartUptime(before)=" + restartUptime + " restart=" + localStorage.getItem("restartUptime")
                    + "\n restartTime(local)=" + localStorage.getItem("restartTime")
                    + "\n diff2=" + diff2
                    + "\n common=" + localStorage.getItem("commonTime") + " commonDiff=" + localStorage.getItem("commonDiff");
                this.additionalDebug = this.lastKnownUptime;
                // this.newRelicService.recordBreadcrumb('OfflineUptime_NoRestart', {
                //     service: 'mobileLogin-api.service',
                //     methodName: 'checkOfflineUptime()',
                //     uptime,
                //     diff2,
                //     storedUptime,
                //     lastKnownUptime,
                //     restartDiff,
                //     //isOnline: this.networkService.userIsOnline2(),
                //     timestamp: Date.now()
                // });
            }
            //this.rollbarErrorHandler.offlineLog("Offline Restart: " + this.additionalDebug);
            //we set last known uptime so that we do not do the restart check twice for the same restart, and therefore end up adding the same restart twice
            this.uptimeService.setLastKnownUptime(uptime);

            this.offlineTimeChecked = true;
            this.updateStoredUptime();
        })
            .catch(error => {
                // this.newRelicService.recordError("Error in mobileLogin-api.service.checkOfflineUptime() Message: " + error?.message,error.stack)
                console.log(error);
            });
    }

    saveLocation(isOnline: boolean, data) {
        return new Promise<string>(resolve => {
            if (isOnline == true && !this.requestService.offlineMode) {
                this.requestService.getUTCTime().then(time => {
                    var timeStr = moment(time, DateTimeWebFormat).format(DateTimeFormat); //add timezone
                    this.addWorkerCoordinates(data, timeStr);
                    resolve(timeStr);
                });
            } else {
                if (this.plt.is('cordova')) {
                    this.uptimeService.getOfflineTime().then(timeStr => {
                        this.addWorkerCoordinates(data, timeStr);
                    });
                    resolve(timeStr);
                } else {
                    var timeStr = moment().subtract(moment().utcOffset(), 'minute').format(DateTimeFormat);
                    this.addWorkerCoordinates(data, timeStr);
                    resolve(timeStr);
                }
            }
        });
    }

    addWorkerCoordinates(data: any, timeStr: string) {
        if (this.requestService.workerData) {
            this.storage.get(this.offlineManager.workerCoordinates).then(cacheArray => {
                var newWorkerCoordinates = new WorkerCoordinates(this.requestService.workerData.MemberId, this.requestService.workerData.BusinessId, data.coords.latitude, data.coords.longitude, data.timestamp, timeStr);
                var workerCoordinatesArray = new Array<WorkerCoordinates>();
                if (cacheArray != null) {
                    workerCoordinatesArray = cacheArray;
                }
                workerCoordinatesArray.push(newWorkerCoordinates);
                this.storage.set(this.offlineManager.workerCoordinates, workerCoordinatesArray);
            });
        }
    }

    syncWorkerCoordinates() {
        this.storage.get(this.offlineManager.workerCoordinates).then(cacheArray => {
            this.requestService.sendWorkerCoordinates(cacheArray).then(result => {
                this.storage.remove(this.offlineManager.workerCoordinates);
            });
        });
    }

    clearWorkerCoordinates() {
        this.storage.remove(this.offlineManager.workerCoordinates);
    }
}
